import {type FunctionalComponent, h} from '@stencil/core';
import type {SearchApiGenericResult} from '../../../../../../../api/model/response/documents/SearchResult';
import type {ExstUnionUiModel} from '../../../../../../../models/ui/documents/exchange/exst-union-ui.model';
import type {DocumentBaseUiModel} from '../../../../../../../models/ui/documents/document-base-ui.model';
import {SrtRating} from '../../../../../result-cards/utils/srt-rating';
import type {Strategies} from '../../../../../../strategies/Strategies';
import type {InternalAddressesStrategyService} from '../../../../../../strategies/InternalAddressesStrategyService';
import {INTERNAL_ADDRESSES} from '../../../../../../strategies/utils/variables';
import type {SrtDocument} from '../../../../../../../api/model/response/documents/public/SrtDocument';
import type { labelProviderInterface } from '../../../../../../LabelProviderInterface';




export interface ProductCardContainer {
   gridView?: boolean;
   isDashboardView?: boolean;
   doc: SearchApiGenericResult | ExstUnionUiModel | DocumentBaseUiModel;
   srt: boolean;
   labelProvider: labelProviderInterface
   isDropdownVisible?: boolean;
   sku?: string;
   rangesTerm?: string;
   strategies: Strategies;
   rtl?: boolean;
   isDashboardListVariant?: boolean;
   isCarousel?: boolean;
}

export const ProductCardContainer: FunctionalComponent<ProductCardContainer> = (props, children) => {
    const { doc, gridView, srt, labelProvider, isDropdownVisible, isDashboardView, sku, rangesTerm, strategies, rtl, isDashboardListVariant, isCarousel } = props;
    const internalAddressesStrategy:InternalAddressesStrategyService = strategies.for(INTERNAL_ADDRESSES);
    const isDocumentsOrRangesKeyAvailable = Boolean(sku) || Boolean(rangesTerm);

    return <div class={{
      'result-card__border-wrapper': true,
      'dashboard-view--list-like': isDashboardView && isDashboardListVariant,
      'dashboard-carousel--item': isCarousel,
    }}>
      <div class={{
        'result-card__container': true,
        'grid-view': gridView,
        'dashboard-view--grid-like': isDashboardView && !isDashboardListVariant,
        'product-card-list__item': isDocumentsOrRangesKeyAvailable,
        'product-card-list__item--no-tap-mobile': isDocumentsOrRangesKeyAvailable && isDropdownVisible
      }}
      dir={rtl ? 'rtl' : 'auto'}
      data-card-area={'background'}>
        <a class='result-card__link' href={isDropdownVisible ? void(0) : doc.url}
          target={internalAddressesStrategy.isExternalLink(doc.url) ? '_blank' : '_self'} tabindex={isDropdownVisible ? '-1' : '0'}>
          <div class="result-card__content">
            {children}
          </div>
        </a>
        {srt && (
          <SrtRating doc={doc as unknown as SrtDocument}
            labelProvider={(e, f) => labelProvider(e, f)}/>
        )}
      </div>
    </div>;
};
